import React from 'react';
import {
  Box,
  Heading,
  SimpleGrid,
  VStack,
  IconButton,
  Text,
  Icon,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import {
  MdLocationCity,
  MdOutlineFence,
  MdOutlineAnnouncement,
  MdOutlineContactEmergency,
  MdHomeWork,
  MdOutlineConstruction,
  MdOutlineAssignment,
  MdGroups,
  MdBlock,
  MdGavel,
  MdDescription,
  MdFolderSpecial,
  MdDashboard,
} from 'react-icons/md';

const obrasRoutes = [
  { label: 'Dashboard OP', path: '/admin/obras-dashboard', icon: MdDashboard },
  { label: 'Gestión Integral OP', path: '/admin/gestion-tramites-op', icon: MdFolderSpecial },
  { label: 'Gestión de Trámites', path: '/admin/gestion-tramites', icon: MdDescription },
  { label: 'Urbanización', path: '/admin/urbanizacion', icon: MdLocationCity },
  { label: 'Fraccionamiento', path: '/admin/fraccionamiento', icon: MdOutlineFence },
  { label: 'División de Terrenos', path: '/admin/division-terrenos', icon: MdOutlineFence },
  { label: 'Anuncios', path: '/admin/anuncios', icon: MdOutlineAnnouncement },
  { label: 'Panteones', path: '/admin/panteones', icon: MdOutlineContactEmergency },
  // { label: 'Bases', path: '/admin/construccion-base', icon: MdHomeWork },
  { label: 'Demoliciones', path: '/admin/demoliciones', icon: MdOutlineConstruction },
  { label: 'Constancias', path: '/admin/constancias', icon: MdOutlineAssignment },
  { label: 'Contratistas', path: '/admin/contratistas', icon: MdGroups },
  // { label: 'Obstrucción', path: '/admin/obstruccion-temporal', icon: MdBlock },
  { label: 'Multas', path: '/admin/multas-obstruccion', icon: MdGavel },
];

const ObrasPublicasNavigation = () => {
  const navigate = useNavigate();

  return (
    <Box p={6} pt={79}>
   

      <SimpleGrid columns={{ base: 2, sm: 3, md: 4 }} spacing={6} justifyItems="center">
        {obrasRoutes.map((route) => (
          <VStack key={route.path} spacing={2}>
            <IconButton
              aria-label={route.label}
              icon={<Icon as={route.icon} boxSize={10} />}
              isRound
              size="lg"
              fontSize="2xl"
              bg="#bb8c52"
              color="white"
              _hover={{ bg: "#a67a47" }}
              _active={{ bg: "#a67a47" }}
              onClick={() => navigate(route.path)}
              boxSize="100px"
            />
            <Text fontSize="md" fontWeight={'bold'} textAlign="center">
              {route.label}
            </Text>
          </VStack>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default ObrasPublicasNavigation;
